import React, { useState, useEffect, useRef } from 'react';

//import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";

import ReactHtmlParser/*, { processNodes, convertNodeToElement, htmlparser2 }*/ from 'react-html-parser';

import * as Hosts from '../../../Hosts';
import { reqGET, repo_site_assets_link, repo_img_link, content_language} from '../../../Utils';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Loader from '../../../loader';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

import AssecImage from "../ASSEC_Image/Image"

export default function AboutCustom(props) {

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));

    const [lang_id, set_lang_id] = useState('1');

    const [dados_config, set_dados_config] = useState({});
    const [navbar, set_navbar] = useState({});
    const [dataProjecto, setdataProjecto] = useState([]);
    const [dataEtapas, setdataEtapas] = useState([]);
    const [dataResultados, setdataResultados] = useState([]);

    const [, set_dados_content] = useState(null)

    const content_interface = {
        id: '',
        info: {},
        content: {}
    }
    const content = useRef(content_interface)

    let getinfoProjecto = async () => {
        //setLoading(true)
        await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/217`)
          .then(res => {
            setdataProjecto(res.data)
            //console.log(res.data)
            //setLoading(false)
          })
          .catch(erro => console.log('Erro resultados', erro))
    }

    let getEtapas = async () => {
        //setLoading(true)
        await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/229`)
            .then(res => {
                setdataEtapas(res.data)
                //setLoading(false)
                //console.log(res.data)
            })
            .catch(erro => console.log('Erro etapas', erro))
    }

    let getResultados = async () => {
        //setLoading(true)
        await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/220`)
          .then(res => {
            setdataResultados(res.data)
            //console.log(res.data)
            //setLoading(false)
          })
          .catch(erro => console.log('Erro resultados', erro))
    }

    useEffect(() => {
        
        try {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                set_lang_id(el.id)
                }
            })
            let getInfoProps = async () => { 
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_navbar(props.dados_navbar)
                }
            
                if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                    set_dados_config(props.dados_config)
                }

                set_dados_content(content.current = {id: '', info: {type: 'project', layout: 'all'}, content: []})
            }

            (async () => {
                await getInfoProps()
                await getinfoProjecto()
                await getEtapas()
                await getResultados()
                setLoading(false)
            })()

            return

        } catch {
            console.log('nada')

			return
		}
        
    }, [props]);

    return (isloading ?
		    <Loader />
		:
            <>
                <Navbar dados_config={dados_config} dados_navbar={navbar} />
                <Breadcrumb dados_config={dados_config} dados_navbar={navbar} dados_content={content.current} />
                <main className="about-custom">
                    <section id="projecto" className="py-5">
                        <div className="container">
                            <div className="row">
                                {
                                    dataProjecto.map((v, key) => {
                                        return (
                                        <div key={key} className="col-12">
                                            <div className='title-properties'>
                                                <h1 className={v.content[0].title !== '' ? "titulo-pp" : "d-none"}>
                                                    {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id] === null || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                                </h1>
                                                { 
                                                    v.content[0].subtitle !== '' ?
                                                        <h2 className={v.content[0].subtitle !== '' ? "subtitulo-pp" : "d-none"}>
                                                            {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id] === null || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                                        </h2>
                                                    :
                                                        null
                                                }
                                                <hr></hr>
                                            </div>
                                            {
                                                lang !== 'pt' && v.content[0]['language'] !== undefined && v.content[0]['language'][lang_id] !== undefined && v.content[0]['language'][lang_id] !== null && v.content[0]['language'][lang_id]['media'] !== null && v.content[0]['language'][lang_id]['media']['image'] !== undefined && v.content[0].language[lang_id]['media']['image'].length > 0 ?
                                                    v.content[0]['language'][lang_id]['media']['image'][0]['type'] === 'video' ?
                                                        <div className='iframe-youtube col-12 col-md-9 mx-auto mb-3 mb-md-5'>
                                                            <div className="ratio ratio-16x9">
                                                                <iframe
                                                                    src={v.content[0]['language'][lang_id]['media']['image'][0]['link'].replace('watch?v=', 'embed/') + "?autoplay=1&mute=1&controls=1&loop=0"}
                                                                    title={(v.content[0]['language'][lang_id]['media']['image'][0]['name'].includes('youtube.com') || v.content[0]['language'][lang_id]['media']['image'][0]['name'] === '') ? 'YouTube video player' : v.content[0]['language'][lang_id]['media']['image'][0]['name']}
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media;
                                                                    gyroscope; picture-in-picture;
                                                                    web-share"
                                                                    allowFullScreen>
                                                                </iframe>
                                                            </div>
                                                        </div>

                                                    :

                                                        <a
                                                            href={v.content[0]['language'][lang_id]['media']['image'][0]['link']}
                                                            data-fancybox="gallery"
                                                            data-caption={(v.content[0]['language'][lang_id]['media']['image'][0]['name'].includes('webp') || v.content[0]['language'][lang_id]['media']['image'][0]['name'].includes('jpg') || v.content[0]['language'][lang_id]['media']['image'][0]['name'].includes('png')) ? '' : v.content[0]['language'][lang_id]['media']['image'][0]['name']}
                                                        >
                                                            <div className="div-banner mb-3 mb-md-5"> 
                                                                <AssecImage 
                                                                    linkImage={v.content[0]['language'][lang_id]['media']['image'][0]['link']}
                                                                    width="1296"
                                                                    height="720"
                                                                    fit='crop'
                                                                    type='img'
                                                                    sClass="img-fluid" 
                                                                    alt={v.content[0]['language'][lang_id]['media']['image'][0]['name']}
                                                                />
                                                                {/*<img src={v.content[0]['language'][lang_id]['media']['image'][0]['link']} className="img-fluid" alt={v.content[0]['language'][lang_id]['media']['image'][0]['name']} />*/}
                                                            </div>
                                                        </a>

                                                :

                                                    v.content[0]['media'] !== undefined && v.content[0]['media']['image'] !== undefined && v.content[0]['media']['image'].length > 0 ? (
                                                        v.content[0]['media']['image'][0]['type'] === 'video' ?
                                                            <div className='iframe-youtube col-12 col-md-9 mx-auto mb-3 mb-md-5'>
                                                                <div className="ratio ratio-16x9">
                                                                    <iframe
                                                                        src={v.content[0]['media']['image'][0]['link'].replace('watch?v=', 'embed/') + "?autoplay=1&mute=1&controls=1&loop=0"}
                                                                        title={(v.content[0]['media']['image'][0]['name'].includes('youtube.com') || v.content[0]['media']['image'][0]['name'] === '') ? 'YouTube video player' : v.content[0]['media']['image'][0]['name']}
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media;
                                                                        gyroscope; picture-in-picture;
                                                                        web-share"
                                                                        allowFullScreen>
                                                                    </iframe>
                                                                </div>
                                                            </div>

                                                        :

                                                            <a
                                                                href={v.content[0]['media']['image'][0]['link']}
                                                                data-fancybox="gallery"
                                                                data-caption={(v.content[0]['media']['image'][0]['name'].includes('webp') || v.content[0]['media']['image'][0]['name'].includes('jpg') || v.content[0]['media']['image'][0]['name'].includes('png')) ? '' : v.content[0]['media']['image'][0]['name']}
                                                            >
                                                                <div className="div-banner mb-3 mb-md-5">
                                                                    <AssecImage 
                                                                        linkImage={v.content[0]['media']['image'][0]['link']}
                                                                        width="1296"
                                                                        height="720"
                                                                        fit='crop'
                                                                        type='img'
                                                                        sClass="img-fluid" 
                                                                        alt={v.content[0]['media']['image'][0]['name']}
                                                                    />
                                                                    {/*<img src={v.content[0]['media']['image'][0]['link']} className="img-fluid" alt={v.content[0]['media']['image'][0]['name']} />*/}
                                                                </div>
                                                            </a>
                                                        

                                                    ) : null 

                                            }
                                            <div className="div-content">
                                                { 
                                                    v.content[0].text !== '' && v.content[0].text !== '<p></p>\n' ?
                                                        <div className="div-text">
                                                            {ReactHtmlParser(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id] === null || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' || v.content[0].language[lang_id].text === '<p></p>\n' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                                        </div>
                                                    :
                                                        null
                                                }
                                                {
                                                    lang !== 'pt' && v.content[0]['language'] !== undefined && v.content[0]['language'][lang_id] !== undefined && v.content[0]['language'][lang_id] !== null && v.content[0]['language'][lang_id]['media'] !== null && v.content[0]['language'][lang_id]['media']['doc'] !== undefined && v.content[0].language[lang_id]['media']['doc'].length > 0 ?
                                                        <div className='div-documents mt-3'>
                                                            {
                                                                v.content[0].language[lang_id]['media']['doc'].map((el_doc, k_doc) => {
                                                                    return (
                                                                        <a key={k_doc} href={el_doc.link} className="btn btn-primary mb-2 me-2" rel="noreferrer" target="_blank">
                                                                            {el_doc.name}<i className="bi bi-filetype-pdf ps-2 fs-6"></i>
                                                                        </a>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    :
                                                        v.content[0]['media'] !== undefined && v.content[0]['media']['doc'] !== undefined && v.content[0].media.doc.length > 0 ? (
                                                            <div className='div-documents mt-3'>
                                                                {
                                                                    v.content[0].media.doc.map((el_doc, k_doc) => {
                                                                        return (
                                                                            <a key={k_doc} href={el_doc.link} className="btn btn-primary mb-2 me-2" rel="noreferrer" target="_blank">
                                                                                {el_doc.name}<i className="bi bi-filetype-pdf ps-2 fs-6"></i>
                                                                            </a>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        ) : null 
                                                }
                                            </div>
                                        </div>
                                        )
                                    })
                                }
                            
                            </div>
                        </div>
                    </section>
                    <section id="etapas" className="py-5">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    {
                                        dataEtapas.map((v, key) => {
                                            return (
                                            <div className="row" key={key}>
                                                <div className="col-12 title-properties">
                                                <h3 className="titulo-pp">
                                                    {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                                </h3>
                                                </div>
                                                <div className="col-12">
                                                    <div className="row gy-4 justify-content-center">
                                                        {
                                                        v.content.slice(1).map((v2, key2) => {
                                                            return (
                                                            <div className="col-12 col-md-6 col-lg-4 col-xxl" key={key2} >
                                                                <a
                                                                    href={v2.media.image[0].link}
                                                                    data-fancybox="gallery"
                                                                    data-caption={(v2.media.image[0].name.includes('webp') || v2.media.image[0].name.includes('jpg') || v2.media.image[0].name.includes('png')) ? v2.title : v2.media.image[0].name}
                                                                >
                                                                    <div className='etapa-container'>
                                                                        <div className='etapa-imagem'>
                                                                            <AssecImage
                                                                            linkImage={v2.media.image[0].link !== undefined ? v2.media.image[0].link : repo_img_link('nophoto.png')}
                                                                            width="500"
                                                                            height="500"
                                                                            fit='crop'
                                                                            type='img'
                                                                            sClass='img-fluid'
                                                                            alt={'Etapa ' + v2.title}
                                                                            title={v2.title}
                                                                            />
                                                                        </div>
                                                                        <div className='etapa-content'>
                                                                            <div className="etapa-titulo">
                                                                            {v2.title}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            )
                                                        })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                    <section id="comparativo" className="py-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 title-properties">
                                    <h3 className="titulo-pp">
                                        Soluções Tecnológicas e Poupança Energética
                                    </h3>
                                </div>
                                <div className="col-12 col-md-6">
                                    <img className='img-fluid' src={repo_site_assets_link("solucao.png")} alt="solução" title="Solução Tecnológica" />
                                </div>
                                <div className="col-12 col-md-6">
                                    <img className='img-fluid' src={repo_site_assets_link("poupanca.png")} alt="poupança" title="Poupança de Energia Estimada" />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section id="resultados" className="py-5">
                        <div className="container">
                            <div className="row">
                                {
                                    dataResultados.map((v, key) => {
                                        return (
                                        <div key={key} className="col-12">
                                            <div className='title-properties'>
                                                <h3 className={v.content[0].title !== '' ? "titulo-pp" : "d-none"}>
                                                    {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id] === null || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                                </h3>
                                                { 
                                                    v.content[0].subtitle !== '' ?
                                                        <h3 className={v.content[0].subtitle !== '' ? "subtitulo-pp" : "d-none"}>
                                                            {lang === 'pt' || v.content[0].language === undefined ? v.content[0].subtitle : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id] === null || v.content[0].language[lang_id].subtitle === undefined || v.content[0].language[lang_id].subtitle === '' ? v.content[0].subtitle : v.content[0].language[lang_id].subtitle)}
                                                        </h3>
                                                    :
                                                        null
                                                }
                                                <hr></hr>
                                            </div>
                                            {
                                                lang !== 'pt' && v.content[0]['language'] !== undefined && v.content[0]['language'][lang_id] !== undefined && v.content[0]['language'][lang_id] !== null && v.content[0]['language'][lang_id]['media'] !== null && v.content[0]['language'][lang_id]['media']['image'] !== undefined && v.content[0].language[lang_id]['media']['image'].length > 0 ?

                                                    <a
                                                        href={v.content[0]['language'][lang_id]['media']['image'][0]['link']}
                                                        data-fancybox="gallery"
                                                        data-caption={(v.content[0]['language'][lang_id]['media']['image'][0]['name'].includes('webp') || v.content[0]['language'][lang_id]['media']['image'][0]['name'].includes('jpg') || v.content[0]['language'][lang_id]['media']['image'][0]['name'].includes('png')) ? '' : v.content[0]['language'][lang_id]['media']['image'][0]['name']}
                                                    >
                                                        <div className="div-banner mb-3 mb-md-5"> 
                                                            <AssecImage 
                                                                linkImage={v.content[0]['language'][lang_id]['media']['image'][0]['link']}
                                                                width="1296"
                                                                height="720"
                                                                fit='crop'
                                                                type='img'
                                                                sClass="img-fluid" 
                                                                alt={v.content[0]['language'][lang_id]['media']['image'][0]['name']}
                                                            />
                                                            {/*<img src={v.content[0]['language'][lang_id]['media']['image'][0]['link']} className="img-fluid" alt={v.content[0]['language'][lang_id]['media']['image'][0]['name']} />*/}
                                                        </div>
                                                    </a>

                                                :

                                                    v.content[0]['media'] !== undefined && v.content[0]['media']['image'] !== undefined && v.content[0]['media']['image'].length > 0 ? (
                                                        <a
                                                            href={v.content[0]['media']['image'][0]['link']}
                                                            data-fancybox="gallery"
                                                            data-caption={(v.content[0]['media']['image'][0]['name'].includes('webp') || v.content[0]['media']['image'][0]['name'].includes('jpg') || v.content[0]['media']['image'][0]['name'].includes('png')) ? '' : v.content[0]['media']['image'][0]['name']}
                                                        >
                                                            <div className="div-banner mb-3 mb-md-5">
                                                                <AssecImage 
                                                                    linkImage={v.content[0]['media']['image'][0]['link']}
                                                                    width="1296"
                                                                    height="720"
                                                                    fit='crop'
                                                                    type='img'
                                                                    sClass="img-fluid" 
                                                                    alt={v.content[0]['media']['image'][0]['name']}
                                                                />
                                                                {/*<img src={v.content[0]['media']['image'][0]['link']} className="img-fluid" alt={v.content[0]['media']['image'][0]['name']} />*/}
                                                            </div>
                                                        </a>

                                                    ) : null 

                                            }
                                            <div className="div-content">
                                                { 
                                                    v.content[0].text !== '' && v.content[0].text !== '<p></p>\n' ?
                                                        <div className="div-text">
                                                            {ReactHtmlParser(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id] === null || v.content[0].language[lang_id].text === undefined || v.content[0].language[lang_id].text === '' || v.content[0].language[lang_id].text === '<p></p>\n' ? v.content[0].text : v.content[0].language[lang_id].text))}
                                                        </div>
                                                    :
                                                        null
                                                }
                                                {
                                                    lang !== 'pt' && v.content[0]['language'] !== undefined && v.content[0]['language'][lang_id] !== undefined && v.content[0]['language'][lang_id] !== null && v.content[0]['language'][lang_id]['media'] !== null && v.content[0]['language'][lang_id]['media']['doc'] !== undefined && v.content[0].language[lang_id]['media']['doc'].length > 0 ?
                                                        <div className='div-documents mt-3'>
                                                            {
                                                                v.content[0].language[lang_id]['media']['doc'].map((el_doc, k_doc) => {
                                                                    return (
                                                                        <a key={k_doc} href={el_doc.link} className="btn btn-primary mb-2 me-2" rel="noreferrer" target="_blank">
                                                                            {el_doc.name}<i className="bi bi-filetype-pdf ps-2 fs-6"></i>
                                                                        </a>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    :
                                                        v.content[0]['media'] !== undefined && v.content[0]['media']['doc'] !== undefined && v.content[0].media.doc.length > 0 ? (
                                                            <div className='div-documents mt-3'>
                                                                {
                                                                    v.content[0].media.doc.map((el_doc, k_doc) => {
                                                                        return (
                                                                            <a key={k_doc} href={el_doc.link} className="btn btn-primary mb-2 me-2" rel="noreferrer" target="_blank">
                                                                                {el_doc.name}<i className="bi bi-filetype-pdf ps-2 fs-6"></i>
                                                                            </a>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        ) : null 
                                                }
                                            </div>
                                        </div>
                                        )
                                    })
                                }
                            
                            </div>
                        </div>
                    </section>
                </main>
                <Footer dados_config={dados_config} dados_navbar={navbar} />
            </>
    )
}